import { render, staticRenderFns } from "./AddProfileForm.vue?vue&type=template&id=067363c6&"
import script from "./AddProfileForm.vue?vue&type=script&lang=js&"
export * from "./AddProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports